import {ChangeDetectorRef, Component, ElementRef, Renderer2} from '@angular/core';
import {IconFieldConfig} from '../icon-field.config';
import {DynamicFormService} from '../../../dynamic-form/dynamic-form.service';
import {BaseFieldComponent} from '../../base/base-field/base-field.component';
import {EventDispatcherService} from '../../../events/event-dispatcher.service';

@Component({
    selector: 'mydocma-form-icon-field',
    templateUrl: './icon-field.component.html',
    styleUrls: ['./icon-field.component.scss']
})
export class IconFieldComponent extends BaseFieldComponent<IconFieldConfig>  {

    public readonly staticCssClass = 'mydocma-icon-field';

    constructor(
        public readonly dynamicFormService: DynamicFormService,
        public readonly changeDetectorRef: ChangeDetectorRef,
        public readonly eventDispatcher: EventDispatcherService,
        element: ElementRef,
        renderer: Renderer2
    ) {
        super(dynamicFormService, changeDetectorRef, eventDispatcher,element,renderer);
    }

    public onClick() {
        if ((this.fieldWrapper.config as IconFieldConfig).click) {
            (this.fieldWrapper.config as IconFieldConfig).click();
        }

        this.eventDispatcher.notifyControlClick(this.fieldWrapper.config);
    }
}
